import { documentToPlainTextString } from '@contentful/rich-text-plain-text-renderer';

function sectionCardImgBgColorAdapter(data: any): any {
    return {
        heading: data.tituloGeneral ?? '',
        tagline: data.descripcion ? documentToPlainTextString(JSON.parse(data.descripcion.raw)) : '',
        cards:
            data?.referenciaPlantillaContenido?.map((card: any) => ({
                title: card.tituloBanner ?? '',
                description: card.descripcion ? documentToPlainTextString(JSON.parse(card.descripcion.raw)) : '',
                img: card.imagenPrincipal ? card.imagenPrincipal[0].file.url : '',
                variant: card.tituloDescripcion ?? ''
            })) ?? [],
    };
}

export default sectionCardImgBgColorAdapter;
